import { render, staticRenderFns } from "./CouponForBundleUpdateForm.vue?vue&type=template&id=2bf97a3a&"
import script from "./CouponForBundleUpdateForm.vue?vue&type=script&lang=js&"
export * from "./CouponForBundleUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports